import { useState } from 'react';
import { Drawer } from '@mui/material';
import { WizardProvider } from 'redesign';
import { BulkActionProvider } from 'shared/providers/bulk-action-provider';
import { BulkShiftActionData } from 'api';
import { BulkShiftForwardFormProvider } from './bulk-shift-forward-form/bulk-shift-forward-form-provider';
import { BulkShiftActionResult } from './bulk-shift-action-result/bulk-shift-action-result';

type Props = {
  selectedShiftIds: string[];
  isBulkSideBarOpen: boolean;
  setIsBarSideBarOpen: (isOpen: boolean) => void;
};

export const BulkForwardToPartnerSidebar = ({
  selectedShiftIds,
  isBulkSideBarOpen,
  setIsBarSideBarOpen,
}: Props) => {
  const [mutationResult, setMutationResult] = useState<BulkShiftActionData>({
    fulfilled: [],
    failure: [],
  });

  return (
    <BulkActionProvider
      setMutationResult={setMutationResult}
      selectedIds={selectedShiftIds}
      failure={mutationResult.failure}
      fulfilled={mutationResult.fulfilled}
    >
      <Drawer
        anchor="right"
        open={isBulkSideBarOpen}
        onClose={() => setIsBarSideBarOpen(false)}
        PaperProps={{ style: { width: 600 } }}
      >
        <WizardProvider onClose={() => setIsBarSideBarOpen(false)}>
          <BulkShiftForwardFormProvider onClose={() => setIsBarSideBarOpen(false)} />
          <BulkShiftActionResult />
        </WizardProvider>
      </Drawer>
    </BulkActionProvider>
  );
};
